import { API_ROOT } from '../../config/config'
import { doGet, doPost } from './utils'

//const API_ROOT = 'http://localhost:9003/api'

export const getSchema = (projectId) => {
  const url = `${API_ROOT}/review/${projectId}/page/approve`
  return doGet(url)
}

export const saveApproveExpert = (request) => {
  const url = `${API_ROOT}/review/reviewer-approved`
  return doPost(url, request)
}

export const getMultiApproveExpertSchema = (groupId) => {
  const url = `${API_ROOT}/review/multi/approve-reviewer/page/${groupId}`
  return doGet(url)
}

export const getMultiApproveExpertData = (groupId, pagesize, pagenumber) => {
  const url = `${API_ROOT}/review/multi/approve-reviewer/project-list/${groupId}/pagenumber/${pagenumber}/pagesize/${pagesize}`
  return doGet(url)
}

export const saveMultiApproveExpert = (request) => {
  const url = `${API_ROOT}/review/multi/reviewer-approved`
  return doPost(url, request)
}
